module.exports = __webpack_public_path__ + "static/media/hospital-orderly.85be79b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/sliderPuzzle/hospital-orderly.png
// module id = 522
// module chunks = 0